export default "__VITE_ASSET__CT3UCfS1__"